<button type="button" class="account-selector-trigger" [matMenuTriggerFor]="accountMenu">
  @if (triggerFlagClass()) {
    <span [class]="'country-flag-icon account-selector-flag ' + triggerFlagClass()"></span>
  } @else {
    <mat-icon class="account-selector-icon">domain</mat-icon>
  }
  <span class="account-selector-label" [matTooltip]="label() ?? ''" appTooltipWhenTruncated>
    @if (allSelected()) {
      {{ "dashboard-new.top-bar.all-accounts" | translate }}
    } @else if (label()) {
      {{ label() }}
    } @else if (currentSelected()) {
      {{ "dashboard-new.top-bar.current-account" | translate }}
    } @else {
      {{ "dashboard-new.top-bar.accounts-selected" | translate: { count: selectedCount() } }}
    }
  </span>
  <mat-icon class="account-selector-arrow">arrow_drop_down</mat-icon>
</button>

<mat-menu #accountMenu="matMenu" class="account-selector-menu" (closed)="menuClosed($event)">
  <div class="account-selector-top-row">
    <button type="button" mat-menu-item class="account-selector-menu-item" data-test="account-selector-all-accounts" (click)="selectAll()">
      <mat-icon class="account-selector-check">{{ allSelected() ? "radio_button_checked" : "radio_button_unchecked" }}</mat-icon>
      <mat-icon class="account-selector-menu-icon">domain</mat-icon>
      <span class="account-selector-name">{{ "dashboard-new.top-bar.all-accounts" | translate }}</span>
    </button>
    <button type="button" class="account-selector-apply" data-test="account-selector-apply-button" [disabled]="!canApply()" (click)="apply()">
      {{ "generic.apply" | translate }}
    </button>
  </div>
  @for (account of displayedAccounts(); track account.id) {
    <button type="button" mat-menu-item class="account-selector-menu-item" (click)="toggle(account.id); $event.stopPropagation()">
      <mat-icon class="account-selector-check">{{ account.selected ? "check_box" : "check_box_outline_blank" }}</mat-icon>
      @if (account.flagClass) {
        <span class="account-selector-flag-slot">
          <span [class]="'country-flag-icon account-selector-flag ' + account.flagClass"></span>
        </span>
      } @else {
        <mat-icon class="account-selector-menu-icon">domain</mat-icon>
      }
      <span class="account-selector-name" [matTooltip]="account.name" appTooltipWhenTruncated>{{ account.name }}</span>
      @if (account.current) {
        <span class="account-selector-current-tag" data-test="account-selector-current-tag">{{ "dashboard-new.top-bar.current-account" | translate }}</span>
      }
    </button>
  }
</mat-menu>
